import React from "react";
import { Box } from "theme-ui";

interface THProps {
  children: React.ReactNode;
}

function TH(props: THProps) {
  return (
    <Box
      as="th"
      {...props}
      sx={{
        borderBottom: "1px solid",
        borderBottomColor: "#666666",
        fontSize: "14px",
        fontWeight: "bold",
        padding: "10px 0",
      }}
    />
  );
}

export default TH;
